import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Baby, 
  Calendar, 
  Activity, 
  FileText, 
  Settings, 
  LogOut,
  User
} from 'lucide-react';

const ParentNavigation = ({ onLogout }) => {
  const location = useLocation();

  const menuItems = [
    {
      name: 'Dashboard',
      icon: Home,
      href: '/parent/dashboard'
    },
    {
      name: 'Minhas Crianças',
      icon: Baby,
      href: '/parent/children'
    },
    {
      name: 'Sessões',
      icon: Calendar,
      href: '/parent/sessions'
    },
    {
      name: 'Comportamentos',
      icon: Activity,
      href: '/parent/behaviors'
    },
    {
      name: 'Planos de Tratamento',
      icon: FileText,
      href: '/parent/treatment-plans'
    },
    {
      name: 'Configurações',
      icon: Settings,
      href: '/parent/settings'
    }
  ];

  return (
    <div className="bg-white shadow-sm border-r border-gray-200 w-64 min-h-screen">
      {/* Logo/Brand */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex flex-col gap-1">
          <img src="/brand/gia-logo-compact.svg" alt="GiA" className="h-10 w-auto self-start" />
          <p className="text-xs text-gray-500">Portal dos Pais</p>
        </div>
      </div>

      {/* Navigation Menu */}
      <nav className="p-4">
        <ul className="space-y-2">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.href;
            
            return (
              <li key={item.name}>
                <Link
                  to={item.href}
                  className={`flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-brand-50 text-brand-700 border border-brand-200'
                      : 'text-gray-700 hover:bg-gray-50 hover:text-gray-900'
                  }`}
                >
                  <Icon className="w-4 h-4" />
                  {item.name}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* User Info & Logout */}
      <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
            <User className="w-4 h-4 text-gray-600" />
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-gray-900">Portal dos Pais</p>
            <p className="text-xs text-gray-500">Acesso restrito</p>
          </div>
        </div>
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-2 px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg transition-colors"
        >
          <LogOut className="w-4 h-4" />
          Sair
        </button>
      </div>
    </div>
  );
};

export default ParentNavigation; 